import { UserAvatar } from "@components/avatar/UserAvatar";
import { useInlineNewVersionNotice } from "@components/newVersion/useInlineNewVersionNotice";
import { PersonalViewNavigationDropdownBody } from "@components/personalView/PersonalViewNavigationDropdownBody";
import { SideNav } from "@design-system/SideNav/SideNav";
import { SideNavHeader } from "@design-system/SideNav/SideNavHeader";
import { SideNavItem } from "@design-system/SideNav/SideNavItem";
import { useUser } from "@hooks/useUser";
import { HomeGridIcon } from "@icons";
import { PersonalHelpMenu } from "./levelHelpMenus";
import { SideNavMenuPicker } from "./SideNavMenuPicker";

/** The personal sidebar on `SideNav`: today's personal menu and a Workspaces row. */
export const PersonalSideNav = () => {
    const user = useUser();
    const newVersionNotice = useInlineNewVersionNotice();

    return (
        <SideNav
            aria-label="Main"
            header={
                <SideNavHeader
                    picker={
                        <SideNavMenuPicker
                            avatar={
                                <UserAvatar user={user} size="sm" aria-hidden />
                            }
                            label={user.preferredName ?? ""}
                        >
                            <PersonalViewNavigationDropdownBody />
                        </SideNavMenuPicker>
                    }
                />
            }
            top={
                <SideNavItem
                    to="/"
                    end
                    icon={<HomeGridIcon />}
                    label="Workspaces"
                />
            }
            footer={
                <>
                    <PersonalHelpMenu />
                    {newVersionNotice}
                </>
            }
        />
    );
};
